.tooltip-header {
  font-weight: 700;
  margin: 5px 0 10px;
  width: 250px;
}

.icon {
  padding: 7px;
}
